import { useEffect } from 'react';
import { App } from './App';
import { AdminPage } from './admin/AdminPage';
import { AcceptInvitePage } from './auth/AcceptInvitePage';
import { AuthGate } from './auth/AuthGate';
import { ForgotPasswordPage } from './auth/ForgotPasswordPage';
import { ResetPasswordPage } from './auth/ResetPasswordPage';
import { useSession } from './lib/authClient';

/** Top-level routing. Navigations are full-page (`window.location`), so reading
 *  the pathname once per load is sufficient — no client router needed. Auth
 *  screens are public; everything else is gated by `AuthGate`. */
export const AppRoot = () => {
  const path = window.location.pathname;

  if (path === '/accept-invite') return <AcceptInvitePage />;
  if (path === '/forgot-password') return <ForgotPasswordPage />;
  if (path === '/reset-password') return <ResetPasswordPage />;

  return <AuthGate>{path === '/admin' ? <AdminRoute /> : <App />}</AuthGate>;
};

/** Inside AuthGate the session is present; bounce non-admins back to the app.
 *  (The server's `requireAdmin` is the real boundary — this is just UX.) */
const AdminRoute = () => {
  const { data } = useSession();
  const isAdmin = data?.user.role === 'admin';

  useEffect(() => {
    if (data && !isAdmin) window.location.href = '/';
  }, [data, isAdmin]);

  return isAdmin ? <AdminPage /> : null;
};
